'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var react = require('@chakra-ui/react');
var times = require('lodash/times.js');
var isFunction = require('lodash/isFunction.js');
var utils = require('@chakra-ui/utils');
require('../../icons/AccountAdd.js');
require('../../icons/AccountCheck.js');
require('../../icons/AccountRemove.js');
require('../../icons/AccountStar.js');
require('../../icons/Account.js');
require('../../icons/ArrowCollapse.js');
require('../../icons/ArrowDownDrop.js');
require('../../icons/ArrowExpand.js');
require('../../icons/ArrowLeftDrop.js');
require('../../icons/ArrowLeft.js');
require('../../icons/ArrowRightDrop.js');
require('../../icons/Bell.js');
require('../../icons/BullhornOutline.js');
require('../../icons/BurgerMenu.js');
require('../../icons/CalendarDetailed.js');
require('../../icons/CalendarOutline.js');
require('../../icons/CashOff.js');
require('../../icons/Cash.js');
require('../../icons/CautionDecagram.js');
require('../../icons/CautionOutline.js');
require('../../icons/CheckCircled.js');
require('../../icons/CheckDecagram.js');
require('../../icons/CheckOutlinedCircled.js');
require('../../icons/Check.js');
require('../../icons/ChevronDown.js');
require('../../icons/ChevronLeft.js');
require('../../icons/ChevronRight.js');
require('../../icons/ChevronUp.js');
require('../../icons/CircleOutline.js');
require('../../icons/ClipboardTextOutline.js');
require('../../icons/Clock.js');
require('../../icons/CloseCircleFilled.js');
require('../../icons/Close.js');
require('../../icons/CompareArrows.js');
require('../../icons/Corner.js');
require('../../icons/Critical.js');
require('../../icons/Delete.js');
require('../../icons/DocumentEditCircled.js');
require('../../icons/DocumentEditOutline.js');
require('../../icons/DotsVertical.js');
require('../../icons/DownloadFilled.js');
require('../../icons/Draft.js');
require('../../icons/Encryption.js');
require('../../icons/EuroOff.js');
require('../../icons/Euro.js');
require('../../icons/EyeOff.js');
require('../../icons/Eye.js');
require('../../icons/FlagCheckered.js');
require('../../icons/FwSet0Constructionyear1.js');
require('../../icons/FwSet0Constructionyear2.js');
require('../../icons/FwSet0Constructionyear3.js');
require('../../icons/FwSet0Constructionyear4.js');
require('../../icons/FwSet0Corner.js');
require('../../icons/FwSet0Corneretc.js');
require('../../icons/FwSet0CultivableLimited.js');
require('../../icons/FwSet0CultivableNo.js');
require('../../icons/FwSet0CultivableUnsure.js');
require('../../icons/FwSet0Cultivable.js');
require('../../icons/FwSet0ElevatorNo.js');
require('../../icons/FwSet0Elevator.js');
require('../../icons/FwSet0Flat.js');
require('../../icons/FwSet0Garage.js');
require('../../icons/FwSet0House.js');
require('../../icons/FwSet0IndustryDontKnow.js');
require('../../icons/FwSet0IndustryIndustry.js');
require('../../icons/FwSet0IndustryLiveBusiness.js');
require('../../icons/FwSet0IndustryOffice.js');
require('../../icons/FwSet0Industry.js');
require('../../icons/FwSet0KitchenNew.js');
require('../../icons/FwSet0KitchenNo.js');
require('../../icons/FwSet0KitchenOld.js');
require('../../icons/FwSet0LandDevelopmentFull.js');
require('../../icons/FwSet0LandDevelopmentInPart.js');
require('../../icons/FwSet0LandDevelopmentNo.js');
require('../../icons/FwSet0Level1.js');
require('../../icons/FwSet0Level2.js');
require('../../icons/FwSet0Level3.js');
require('../../icons/FwSet0Levelplus.js');
require('../../icons/FwSet0LivingspaceUnknown.js');
require('../../icons/FwSet0Livingspace100.js');
require('../../icons/FwSet0Livingspace200.js');
require('../../icons/FwSet0Livingspace200Plus.js');
require('../../icons/FwSet0ParkingNo.js');
require('../../icons/FwSet0Parking.js');
require('../../icons/FwSet0PlotUnknown.js');
require('../../icons/FwSet0Plot.js');
require('../../icons/FwSet0Plot1000.js');
require('../../icons/FwSet0Plot1000Plus.js');
require('../../icons/FwSet0Plot300.js');
require('../../icons/FwSet0Rooms.js');
require('../../icons/FwSet0SemiDetached.js');
require('../../icons/FwSet0TownhouseCorner.js');
require('../../icons/FwSet0TownhouseMiddle.js');
require('../../icons/GiftCircled.js');
require('../../icons/Hausgold.js');
require('../../icons/HelpOutline.js');
require('../../icons/Help.js');
require('../../icons/HomeOutline.js');
require('../../icons/HouseCircled.js');
require('../../icons/HousePerson.js');
require('../../icons/House.js');
require('../../icons/Industry.js');
require('../../icons/InfoFilled.js');
require('../../icons/InfoOutline.js');
require('../../icons/LabelPercent.js');
require('../../icons/Level2.js');
require('../../icons/LightbulbOn.js');
require('../../icons/LockCircledOutline.js');
require('../../icons/Lock.js');
require('../../icons/Magnifier.js');
require('../../icons/Mail.js');
require('../../icons/Map.js');
require('../../icons/MissingOutline.js');
require('../../icons/OkCircled.js');
require('../../icons/OpenBookOutline.js');
require('../../icons/PageFirst.js');
require('../../icons/PageLast.js');
require('../../icons/Pause.js');
require('../../icons/Pen.js');
require('../../icons/Percent.js');
require('../../icons/PhoneCircled.js');
require('../../icons/Phone.js');
require('../../icons/PiggyBankCircled.js');
require('../../icons/PiggyBank.js');
require('../../icons/Plus.js');
require('../../icons/PremiumStars.js');
require('../../icons/Printer.js');
require('../../icons/RealtyCommercial.js');
require('../../icons/RealtyFlat.js');
require('../../icons/RealtyHouse.js');
require('../../icons/RealtySite.js');
require('../../icons/Rocket.js');
require('../../icons/Rooms.js');
require('../../icons/SpeechBubble.js');
require('../../icons/SpeechBubbles.js');
require('../../icons/Speedometer.js');
var Star = require('../../icons/Star.js');
require('../../icons/StatusDontknow.js');
require('../../icons/SwapHorizontalBold.js');
require('../../icons/ThumbDownOutline.js');
require('../../icons/ThumbUpOutline.js');
require('../../icons/TruckFastOutline.js');
require('../../icons/UnorderedList.js');
require('../../icons/User.js');
var RatingIcon = require('./RatingIcon.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var times__default = /*#__PURE__*/_interopDefaultLegacy(times);
var isFunction__default = /*#__PURE__*/_interopDefaultLegacy(isFunction);
var _excluded = ["spacing", "max", "value", "filledColor", "emptyColor", "icon", "editable", "onHover", "onSelect", "className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Rating
 *
 * Component used to display ratings, e.g. 3/5 - or 5/10; with stars by default.
 */
var Rating = react.forwardRef(function (props, ref) {
  // Save at which star (counted from left) the mouse is over atm.
  var _useState = React.useState(null),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    hoverPosition = _useState2[0],
    setHoverPosition = _useState2[1];
  var ownProps = react.omitThemingProps(props);
  var styles = react.useMultiStyleConfig('Rating', props);
  var _ownProps$spacing = ownProps.spacing,
    spacing = _ownProps$spacing === void 0 ? 0.5 : _ownProps$spacing,
    _ownProps$max = ownProps.max,
    max = _ownProps$max === void 0 ? 5 : _ownProps$max,
    value = ownProps.value,
    _ownProps$filledColor = ownProps.filledColor,
    filledColor = _ownProps$filledColor === void 0 ? 'blue.400' : _ownProps$filledColor,
    _ownProps$emptyColor = ownProps.emptyColor,
    emptyColor = _ownProps$emptyColor === void 0 ? 'gray.100' : _ownProps$emptyColor,
    _ownProps$icon = ownProps.icon,
    icon = _ownProps$icon === void 0 ? /*#__PURE__*/React__default["default"].createElement(Star.Star, null) : _ownProps$icon,
    _ownProps$editable = ownProps.editable,
    editable = _ownProps$editable === void 0 ? false : _ownProps$editable,
    onHover = ownProps.onHover,
    onSelect = ownProps.onSelect,
    className = ownProps.className,
    rest = _objectWithoutProperties__default["default"](ownProps, _excluded);
  var containerStyles = _objectSpread({}, styles.container);
  var itemStyles = _objectSpread({
    pl: spacing
  }, styles.item);
  var handleHover = function handleHover() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    // do nothing if in none-edit mode or hover position did not changed
    if (!editable || hoverPosition === index) return;
    setHoverPosition(index);
    if (isFunction__default["default"](onHover)) {
      // start count with 1 instead of 0 to match amount of selected stars
      onHover(index !== null ? index + 1 : null);
    }
  };
  var handleClick = function handleClick(index) {
    if (editable && isFunction__default["default"](onSelect)) {
      // start count with 1 instead of 0
      onSelect(index + 1);
    }
  };
  var getColor = function getColor(index) {
    var starColor = index < value ? filledColor : emptyColor;
    if (hoverPosition !== null && index <= hoverPosition) {
      // define rating color which affects all stars as long as the person hover over.
      var colorLevel = ['red.400',
      // worst
      '#fc8b35',
      // bad
      'yellow.300',
      // average
      'green.400',
      // good
      'green.600' // best
      ];

      // Rating colors only work for an amount of exactly 5 right now.
      // FIXME: Nerd calculation to stretch the colorLevel for more or less stars than 5.
      //  As this is an edge case (never will happen?) i will not do that!
      starColor = colorLevel[hoverPosition >= 5 ? 4 : hoverPosition];
    }
    return starColor;
  };
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    className: utils.cx('chakra-rating', className),
    __css: containerStyles
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, times__default["default"](max, function (index) {
    return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
      __css: itemStyles,
      pl: spacing,
      key: "rating_".concat(index),
      onClick: function onClick(e) {
        e.preventDefault();
        handleClick(index);
      },
      onMouseOver: function onMouseOver() {
        handleHover(index);
      },
      onMouseLeave: function onMouseLeave() {
        handleHover(null);
      }
    }, /*#__PURE__*/React__default["default"].createElement(RatingIcon.RatingIcon, {
      icon: icon,
      color: getColor(index)
    }));
  })));
});
Rating.displayName = 'Rating';
exports.Rating = Rating;